import React from "react";
import Modal from "@mui/material/Modal";
import "./CurrencyModal.scss";
import Close from "../../images/close-light.svg";
import CurrencyModalTable from "./CurrencyModalTable/CurrencyModalTable";

function CurrencyModal({ open, handleClose, selectedCurrency }) {
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="currency-modal-container"
        style={{
          position: "fixed",
          //   transform: "translate(116px, 96px)",
          zIndex: 9999,
          display: "flex",
          //   alignItems: "center",
          //   justifyContent: "center",
          //   width: "80%",
        }}
      >
        <div className="centered-content">
          <div className="text-end">
            <img src={Close} onClick={handleClose} />
          </div>
          <div className="row currency-modal-header">
            <div className="col-3">
              Currency: {selectedCurrency ? selectedCurrency.currency : <></>}
            </div>
            <div className="col-3">Transactions: 2</div>
          </div>
          <div className="currency-modal-table">
            <CurrencyModalTable selectedCurrency={selectedCurrency} />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default CurrencyModal;
